import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showErrorModal } from "../store/slices/errorModalSlice";
import { setErrorRetryFunction } from "../ui/ErrorModal";
import { RefetchFunction } from "src/types/shared.types";
import translation from "../data/fa-IR.json";

interface ErrorObject {
  title?: string;
  detail?: string;
  status?: number;
}

function isErrorObject(err: unknown): err is ErrorObject {
  return (
    typeof err === "object" &&
    err !== null &&
    ("title" in err || "detail" in err || "status" in err)
  );
}

export function useHandleQueryError(
  isError: boolean,
  error: unknown,
  refetch: RefetchFunction
): void {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isError || !isErrorObject(error)) return;

    // Avoid handling 401 here (ProtectedRoute will handle it)
    if (error.status === 401) return;

    // Status 0 = network error/offline
    const errorTitle =
      error.status === 0 ? translation.Global.ServerError : error.title;

    const errorDetail =
      error.status === 0 ? translation.Global.ServerErrorDetail : error.detail;

    dispatch(
      showErrorModal({
        title: errorTitle,
        detail: errorDetail,
        method: "GET",
      })
    );
    setErrorRetryFunction(() => refetch());
  }, [isError, error, refetch, dispatch]);
}
